import { TaskType } from '@eservices/shared/constant';
import { API } from '@eservices/shared/type';
import { getSecondsFrom } from '../../../utils/helpers';

export type EmailTaskFormFields = Omit<
    API.TaskEmail,
    'maxDurationInSeconds' | 'bodyTemplate' | 'bodyJsonTemplate' | 'validationErrors'
> & {
    timeToWait: number;
};

export const convertFormToEmailTask = (
    form: EmailTaskFormFields,
    bodyTemplate: API.ConfigurationFile,
    bodyJsonTemplate: API.ConfigurationFile,
): API.TaskEmail => {
    const { timeToWait, ...rest } = form;
    let { htmlTemplate, attachment } = form;

    if (!bodyTemplate.filename) {
        bodyTemplate = undefined;
    }

    if (!bodyJsonTemplate.filename) {
        bodyJsonTemplate = undefined;
    }

    if (!attachment.filename) {
        attachment = undefined;
    }

    if (!htmlTemplate.filename) {
        htmlTemplate = undefined;
    }

    return {
        ...rest,
        taskType: TaskType.EMAIL,
        maxDurationInSeconds: getSecondsFrom(timeToWait),
        attachment,
        htmlTemplate,
        bodyTemplate,
        bodyJsonTemplate,
        validationErrors: [],
    };
};
